// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"style_imgStyle__3-bVU"};